'use client'

import { useShallow } from 'zustand/react/shallow'
import { useNotebook } from './use-notebook'

/** Block chrome actions — avoids full-store subscription in every slot */
export function useBlockSectionActions() {
  return useNotebook(
    useShallow((s) => ({
      locked: s.locked,
      spawnId: s.lastSpawnSectionId,
      clearSpawnSection: s.clearSpawnSection,
      removeSection: s.removeSection,
      insertSectionAfter: s.insertSectionAfter,
      appendSectionInline: s.appendSectionInline,
      addTab: s.addTab,
      openRichTextInsertMenu: s.openRichTextInsertMenu,
      openMediaAppend: s.openMediaAppend,
      openReferenceAppend: s.openReferenceAppend,
    })),
  )
}
